import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';


import { NavService } from '../../../../services/nav.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@src/app/services/auth.service';
import { AcessoService, MenuItem } from '@src/app/services/acesso.service';

@Component({
    selector: 'app-sidebar',
    imports: [
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    RouterModule
],
    templateUrl: './sidebar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent implements OnInit {
  navopt = this.navService.showClass;
  nomeUsuario: string = '';
  menuItems: MenuItem[] = [];

  constructor(
    public navService: NavService,
    private router: Router,
    private auth: AuthService,
    private acessoService: AcessoService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  logout() {
    try {
      this.auth.logout();
    } finally {
      this.router.navigate(['authentication/login']);
    }
  }

  ngOnInit(): void {
    // Carrega o nome do usuário
    this.auth.getNomeUsuario().subscribe((dados) => {
      this.nomeUsuario = dados.nome!
      .split(' ')
      .splice(0, 2)
      .join(' ');
      this.cdr.markForCheck();
    });

    // Constrói o menu dinâmico baseado nos acessos do usuário
    this.menuItems = this.acessoService.construirMenu();

    // Atualiza o menu quando os acessos mudarem
    this.acessoService.acessos$.subscribe(() => {
      this.menuItems = this.acessoService.construirMenu();
      this.cdr.markForCheck();
    });
  }
}
